module.exports = __webpack_public_path__ + "static/img/2.e2440e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/snip3down/2.png
// module id = EPgB
// module chunks = 35